import BaseObjectStore from './base-object.store';

class DataExportsStore extends BaseObjectStore {
  constructor(props) {
    super(props);
    this.name = 'dataExport';
  }

  resetAllFields() {
    this.resetAllBaseFields();
  }
}

export default new DataExportsStore();